import React from 'react';
import { Link } from 'react-router-dom';
import ENV_CONFIG from '../../env';

const WWW_HOST = ENV_CONFIG.REACT_APP_WWW_HOST;

const NavMarketingMenu = (props) => {
  return (
    <ul className="nav-menu-list">
      <li className="nav-menu-list-item">
        <p>{props.isClient}</p>
        <a
          href={`//${WWW_HOST}/about`}
          className={props.clientStyleVariation ? 'a--green' : 'a--blue'}
        >
          About Us
        </a>
      </li>
      <li className="nav-menu-list-item">
        <a
          href={`//${WWW_HOST}/contact`}
          className={props.clientStyleVariation ? 'a--green' : 'a--blue'}
        >
          Contact Us
        </a>
      </li>
      {props.isLoggedIn ? (
        <li className="nav-menu-list-item nav-menu-list-item--mobile-only">
          <p
            onClick={props.logout}
            className={props.clientStyleVariation ? 'a--green' : 'a--blue'}
          >
            Sign Out
          </p>
        </li>
      ) : (
        <li className="nav-menu-list-item nav-menu-list-item--mobile-only">
          <Link
            to="/login"
            className={props.clientStyleVariation ? 'a--green' : 'a--blue'}
          >
            Sign In
          </Link>
        </li>
      )}
    </ul>
  );
};

export default NavMarketingMenu;



// WEBPACK FOOTER //
// ./src/components/nav/NavMarketingMenu.js